import React from "react";
import { Helmet } from "react-helmet";
import {
  SwanProvider,
  SWAN_STYLE_KEY_MAP,
  getRootClassNames,
  useBrowserClasses,
  SwanHead,
  ScreenClassProvider,
} from "@vp/swan";
import PageConfig from "../utils/PageConfig";

const styleSheetKeys = [
  SWAN_STYLE_KEY_MAP.accordion,
  SWAN_STYLE_KEY_MAP.alertBox,
  SWAN_STYLE_KEY_MAP.button,
  SWAN_STYLE_KEY_MAP.banner,
  SWAN_STYLE_KEY_MAP.carousel,
  SWAN_STYLE_KEY_MAP.core,
  SWAN_STYLE_KEY_MAP.grid,
  SWAN_STYLE_KEY_MAP.hidden,
  SWAN_STYLE_KEY_MAP.icon,
  SWAN_STYLE_KEY_MAP.listbox,
  SWAN_STYLE_KEY_MAP.modalDialog,
  SWAN_STYLE_KEY_MAP.pagination,
  SWAN_STYLE_KEY_MAP.popover,
  SWAN_STYLE_KEY_MAP.pricing,
  SWAN_STYLE_KEY_MAP.progressBar,
  SWAN_STYLE_KEY_MAP.progressiveImage,
  SWAN_STYLE_KEY_MAP.ratingsStars,
  SWAN_STYLE_KEY_MAP.selectionSet,
  SWAN_STYLE_KEY_MAP.spinner,
  SWAN_STYLE_KEY_MAP.standardTile,
  SWAN_STYLE_KEY_MAP.table,
  SWAN_STYLE_KEY_MAP.tabs,
  SWAN_STYLE_KEY_MAP.thumbnailsHero,
  SWAN_STYLE_KEY_MAP.toggleSwitch,
  SWAN_STYLE_KEY_MAP.utility,
  SWAN_STYLE_KEY_MAP.visible,
];

export const SwanConfiguration: React.FC<any> = ({ children, locale, pluginStyleSheetKeys }) => {
  const bodyClassName = getRootClassNames();
  const htmlClassName = useBrowserClasses();
  const allStyleSheetKeys = [...new Set([...styleSheetKeys, ...pluginStyleSheetKeys])];
  return (
    <SwanProvider swanLocale={locale} swanTenant={PageConfig.tenant}>
      <Helmet bodyAttributes={{ class: bodyClassName }} htmlAttributes={{ class: htmlClassName }} />
      <SwanHead
        swanLocale={locale}
        swanTenant={PageConfig.tenant}
        styleSheetKeys={allStyleSheetKeys}
        renderWith={Helmet}
        renderStyleContentAsChildren
      />
      <ScreenClassProvider>{children}</ScreenClassProvider>
    </SwanProvider>
  );
};
